import axios from "axios";
import cookie from "./cookie";
import sessionManager from "../utils/session-manager";
// axios.defaults.timeout = 30000;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
let ajaxurl = "https://prod.ecwms.cn";
import store from '../store'



const AUTH_CODES = {
    PASSWORD_CHANGED: 4001,
    TOKEN_EXPIRED: 4002,
    TOKEN_INVALID: 4003,
    TOKEN_MISSING: 4004,
    NO_PERMISSION: 4005
};

const RELOGIN_CODES = [
    AUTH_CODES.PASSWORD_CHANGED,
    AUTH_CODES.TOKEN_EXPIRED,
    AUTH_CODES.TOKEN_INVALID,
    AUTH_CODES.TOKEN_MISSING
];


function getPasswordChangedPayload(data) {
    if (data && RELOGIN_CODES.indexOf(data.code) >= 0) {
        return Promise.resolve(data)
    }

    if (typeof Blob === "undefined" || !(data instanceof Blob) ||
      data.type.indexOf("application/json") < 0) {
        return Promise.resolve(null)
    }

    return new Promise(resolve => {
        const reader = new FileReader()
        reader.onload = () => {
            try {
                resolve(JSON.parse(reader.result))
            } catch (e) {
                resolve(null)
            }
        }
        reader.onerror = () => resolve(null)
        reader.readAsText(data)
    })
}

function handleUnauthorized(err) {
    if (!err || !err.response) {
        return false;
    }

    const status = err.response.status;

    if (status === 401 && sessionManager.shouldPreserveTokenForProjectRefresh()) {
        return true;
    }

    if (status === 401) {
        const logoutURL = sessionStorage.getItem("logout") || "/login";
        sessionManager.clearUserData();
        window.location.hash = logoutURL;
        return true;
    }

    return false;
}


// 没有token 拦截 有个特殊的没有拦截 登录之类的
axios.interceptors.request.use(
    config => {
        const bearerToken = cookie.getBearerToken();
        if (bearerToken  && !config.skipAuthorization) {
            config.headers.Authorization = bearerToken;
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);



axios.interceptors.response.use(
  response => {
      const headers = response && response.config && response.config.headers;
      if (headers && (headers.Authorization || headers.authorization)) {
          sessionManager.completeProjectRefresh();
      }
      return response;
  },
  error => {
      store.commit("updataLoading", { pbLoading: false });
      if (!error.response || !error.config || error.config.__passwordChangedRetry) {
          return Promise.reject(error)
      }

      const status = error.response.status;

      if (status === 403) {
          const body403 = error.response.data || {};
          store.commit("updataLoading", { pbLoading: false });
          sessionManager.showNoPermissionModal(body403.msg);
          return Promise.reject(error);
      }

      if (status !== 401) {
          return Promise.reject(error)
      }

      return getPasswordChangedPayload(error.response.data).then(payload => {
          if (!payload || RELOGIN_CODES.indexOf(payload.code) < 0) {
              return Promise.reject(error)
          }

          const retryRequest = Object.assign({}, error.config, {
              headers: Object.assign({}, error.config.headers),
              __passwordChangedRetry: true
          })
          delete retryRequest.headers.Authorization
          delete retryRequest.headers.authorization

          store.commit("updataLoading", { pbLoading: false });
          return sessionManager.showPasswordChangedModal(payload.msg)
            .then(() => axios(retryRequest))
      })
  }
);


// 请求方式用post get 就行 其他blob用框架就可以代替
export default {
    exportExcel: function(url,form) {
        return axios({
            method: 'post',
            url: url, // 请求地址  //
            data: form, // 参数
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        })
          .catch(err => {
              handleUnauthorized(err)
              return Promise.reject(err)
          })
    },
    getexportExcel: function(url,form) {
        return axios({
            method: 'get',
            url: url,
            data: form, // 参数
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        })
          .catch(err => {
              handleUnauthorized(err)
              return Promise.reject(err)
          })
    },

    ajaxUrl: function() {
        return ajaxurl;
    },
    post: function(url, data, type, file, skipAuthorization = false) {
        store.commit("updataLoading", { pbLoading: true });
        // 以前的上传现在用框架 以前框架上传用不了
        // 上转excel
        if (type == "from") {
            let param = new FormData();
            param.append("excel", file);
            param.append("btnCriteria", data);
            axios.defaults.headers.common["Content-Type"] = "multipart/form-data";
            data = param;
        }

        if (type == "chardimportExcelImport") {
            let param = new FormData();
            param.append("excel", file);
            param.append("geMapMasterUid", data.geMapMasterUid);
            param.append('moduleCode',data.moduleCode)
            if (data.uids != null && data.uids.length > 0){
                param.append('uids',data.uids)
            }
            axios.defaults.headers.common["Content-Type"] = "multipart/form-data";
            data = param;
        }

        if (type == "chardimportExcel") {
            let param = new FormData();
            param.append("excel", file);
            param.append("geMapMasterUid", data);
            axios.defaults.headers.common["Content-Type"] = "multipart/form-data";
            data = param;
        }


        if (type == "img") {
            let param = new FormData();
            param.append("file", file);
            axios.defaults.headers.common["Content-Type"] = "multipart/form-data";
            data = param;
        }

        if (type == "reportUpload") {
            let param = new FormData();
            param.append("file", file);
            param.append("uid", data.uid);
            axios.defaults.headers.common["Content-Type"] = "multipart/form-data";
            data = param;
        }
        return new Promise((resolve, reject) => {
            url = ajaxurl + url;
            axios
              .post(url, data, skipAuthorization ? { skipAuthorization: true } : undefined)
                .then(res => {
                    store.commit("updataLoading", { pbLoading: false });
                    let { data, status } = res;
                    if (status === 200) {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                })
                .catch(err => {
                    store.commit("updataLoading", { pbLoading: false });
                    handleUnauthorized(err);
                    reject(err);
                });
        });
    },
    noLoadingPostAjax:function(url, data, skipAuthorization = false){
        return new Promise((resolve, reject) => {
            url = ajaxurl + url;
            axios
              .post(url, data, skipAuthorization ? { skipAuthorization: true } : undefined)
                .then(res => {
                    let { data, status } = res;
                    if (status === 200) {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                })
                .catch(err => {
                    handleUnauthorized(err);
                    reject(err);
                });
        });
    },
    get: function(url, data) {
        store.commit("updataLoading", { pbLoading: true });
        return new Promise((resolve, reject) => {
            url = ajaxurl + url;
            axios
                .get(url, { params: data })
                .then(res => {
                    store.commit("updataLoading", { pbLoading: false });
                    let { data, status } = res;
                    if (status === 200) {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                })
                .catch(err => {
                    store.commit("updataLoading", { pbLoading: false });
                    handleUnauthorized(err);
                    reject(err);
                });
        });
    },
    put: function(url, data) {
        return new Promise((resolve, reject) => {
            url = ajaxurl + url;
            axios.put(url, data).then(res => {
                let { data, status } = res;
                if (status === 200) {
                    resolve(data);
                } else {
                    reject(data);
                }
            }).catch(err => {
                handleUnauthorized(err);
                reject(err);
            });
        });
    },
    delete: function(url, data) {
        return new Promise((resolve, reject) => {
            url = ajaxurl + url;
            axios
                .delete(url, data)
                .then(res => {
                    store.commit("updataLoading", { pbLoading: false });
                    let { data, status } = res;
                    if (status === 200) {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                })
                .catch(err => {
                    store.commit("updataLoading", { pbLoading: false });
                    handleUnauthorized(err);
                    reject(err);
                });
        });
    },
    bobleAjax: function(url, data) {
        store.commit("updataLoading", { pbLoading: true });
        return new Promise((resolve, reject) => {
            url = ajaxurl + url;
            // blob
            axios.get(url, data,{responseType: 'blob'}).then(res => {
                store.commit("updataLoading", { pbLoading: false });
                let { data, status } = res;
                if (status === 200) {
                    resolve(data);
                } else {
                    reject(data);
                }
            }).catch(err => {
                store.commit("updataLoading", { pbLoading: false });
                handleUnauthorized(err);
                reject(err);
            });
        });
    },
};